import styles from "./styles.module.scss";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { getScoreColor, getScoreBgColor } from "utils/scoreColor";

interface DoughnutChartProps {
  score: number;
  total?: number;
  className?: string;
  cutout?: string;
  borderRadius?: number[];
  color?: string[];
  plugins?: any[];
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  score,
  total = 100,
  className,
  cutout = "85%",
  color,
}) => {
  // Validate score
  if (typeof score !== 'number' || isNaN(score) || score < 0) {
    return null; // Don't render if score is invalid
  }

  // Ensure score doesn't exceed total
  const validScore = Math.min(score, total);

  // Calculate inner and outer radius from cutout percentage
  const cutoutPercentage = cutout ? parseInt(cutout.replace('%', '')) : 85;
  const innerRadius = cutoutPercentage;
  const outerRadius = 100;

  const data = [
    { name: 'Score', value: validScore },
    { name: 'Remaining', value: total - validScore },
  ];

  const defaultColors = [getScoreColor(validScore), getScoreBgColor(validScore)];

  const colors = color || defaultColors;

  return (
    <div className={`${styles.container} ${className}`}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={`${innerRadius}%`}
            outerRadius={`${outerRadius}%`}
            startAngle={90}
            endAngle={450}
            dataKey="value"
            stroke="transparent"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export { DoughnutChart };